import { useEffect, useRef, useState } from "react";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import PrimaryRightIconFill from "../CommonButtons/PrimaryRightIconFill";
import SingleSelectDropDownComponent from "../CommonDropdown/SingleSelectDropdown";
import TextInputField from "../CommonInputFields/TextInputField";
import AmountInputField from "../CommonInputFields/AmountInputField";
import TitleSubtitlePair from "../TitleSubtitlePair";

const CommonRequestDetailsCard = ({
  beneficiaryName,
  transactionDate,
  category,
  selectedSourceAccount,
  selectedPaymentMethod,
  amount,
  comment,
  paymentMethodOptions,
  onSourceAccountChange,
  onPaymentMethodChange,
  onAmountChange,
  onCommentChange,
  isLoading,
  error,
  entries,
}) => {
  const [isPaymentDropdownOpen, setIsPaymentDropdownOpen] = useState(false);
  const commentInputRef = useRef(null);
  const prevCommentRef = useRef(comment);

  useEffect(() => {
    const wasFilled = prevCommentRef.current && prevCommentRef.current !== "";
    prevCommentRef.current = comment;
    if (wasFilled && !comment && commentInputRef.current) {
      commentInputRef.current.focus();
      const id = setTimeout(
        () => commentInputRef.current?.blur(),
        GlobalConfiguration.lengthCheckZero,
      );
      return () => clearTimeout(id);
    }
  }, [comment]);

  const rowEntries = Array.isArray(entries?.[0]) ? entries[0] : [];

  return (
    <div className=" w-full Qsmd:max-w-max-content-width  mx-auto rounded-border-radius-md bg-primary-card   flex flex-col ">
      <div className="pl-padding-sm pr-padding-sm Qsmd:pl-padding-sm pt-padding-md Qsmd:pt-padding-sm ">
        <div className="flex flex-col Qsmd:flex-row justify-between Qsmd:gap-gap-base gap-top_md w-full border-b  border-primary-bg pb-padding-sm">
          {rowEntries.map((entry, index) => (
            <div
              key={entry.subText ?? index}
              className={`flex w-full ${entry.type !== "cta" && "pl-padding-sm  Qsmd:mt-margin-sm Qsmd:mb-margin-sm "} flex-col gap-gap-xs flex-1  Qsmd:max-w-request-approval-card-max-width ${index > GlobalConfiguration.lengthCheckZero && index !== GlobalConfiguration.lengthCheckThree ? `Qsmd:border-l ${index === GlobalConfiguration.lengthCheckTwo && "Qsmd:border-r Qsmd:border-primary-bg"} Qsmd:border-primary-bg Qsmd:pl-padding-md` : index === GlobalConfiguration.lengthCheckThree ? "Qsmd:pl-padding-sm" : "Qsmd:pr-padding-md"}`}
            >
              <TitleSubtitlePair
                enableTicker
                hoverOption={entry.type === "cta" ? "white" : undefined}
                showArrow={entry.type === "cta"}
                isDisabled={entry.isDisabled ?? false}
                onClick={entry?.onClick}
                title={entry.text ?? ""}
                subtitle={entry.subText ?? ""}
                titleColor={entry.textColor ?? "text-primary"}
                variant="sm"
                isBold={entry.isBold ?? false}
              />
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col Qsmd:flex-row Qsmd:gap-gap-md Qsmd:items-end w-full px-padding-md">
        <div
          className={`flex flex-col gap-gap-xs flex-1 pt-padding-md  Qsmd:pb-padding-md rounded-border-radius-md `}
        >
          <p
            className={`text-font-xs  font-normal ${error?.sourceAccount ? "text-failed" : "text-text-secondary"}`}
          >
            Source account
          </p>

          <PrimaryRightIconFill
            btnText={
              selectedSourceAccount
                ? selectedSourceAccount
                : "Select owner account"
            }
            enabledBgColor="var(--primary-nav-act)"
            isDisabled={false}
            handleFunction={onSourceAccountChange}
            iconToBeAlign="right"
            enabledTextColor={"var(--text-primary)"}
            icon={
              "https://q2pay.in/new_assets/common/arrows/arrow_right_white.svg"
            }
            fullWidthRequired={true}
            hoverOption="white"
            imgColor={"var(--text-primary)"}
            isNeedOutLine={error?.sourceAccount && true}
            isOytLineColor="failed"
          />
        </div>

        <div
          className={`flex flex-col gap-gap-xs flex-1 pt-padding-md Qsmd:pb-padding-md rounded-border-radius-md `}
        >
          <p
            className={`text-font-xs  font-normal ${error?.paymentMethod ? "text-failed" : "text-text-secondary"}`}
          >
            Select payment method
          </p>
          <SingleSelectDropDownComponent
            options={paymentMethodOptions}
            selected={selectedPaymentMethod}
            setSelected={onPaymentMethodChange}
            isOpen={isPaymentDropdownOpen}
            onOpen={() => setIsPaymentDropdownOpen(true)}
            onClose={() => setIsPaymentDropdownOpen(false)}
            placeholder="Select type"
            searchPlaceholder="Search type"
            showSearch={false}
            type="small"
            disabled={isLoading}
            dropdownType="PaymentMethod"
          />
        </div>

        <div className="flex flex-col gap-gap-xs flex-1 pt-padding-md Qsmd:pb-padding-md">
          <AmountInputField
            name="amount"
            variant={error?.amount ? "error" : "default"}
            placeholder="Amount"
            value={amount}
            onInput={(val) => onAmountChange(val)}
            fixedDecimalScale={true}
            bgColor="var(--primary-card)"
            fgColor="var(--text-primary)"
            fontKind="small"
            isDisabled={isLoading}
            isFullWidth={true}
          />
        </div>

        <div className="flex flex-col gap-gap-xs flex-1 pt-padding-md pb-padding-md">
          <TextInputField
            ref={commentInputRef}
            variant="default"
            placeholder="Comment (optional)"
            value={comment}
            onInput={(e) => onCommentChange(e.target.value)}
            bgColor="var(--primary-card)"
            fgColor="var(--text-primary)"
            fontKind="small"
            isDisabled={isLoading}
            isFullWidth={true}
            adornment={""}
          />
        </div>
      </div>
    </div>
  );
};

export default CommonRequestDetailsCard;
